import { render, staticRenderFns } from "./zlbOrderWork.vue?vue&type=template&id=8dafa5be&"
import script from "./zlbOrderWork.vue?vue&type=script&lang=js&"
export * from "./zlbOrderWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports